import { useSearchParams } from 'react-router-dom';
const INT_RE = /^\d+$/;
/**
 * The user whose card is open, kept in the address (`?user=16409`): the link can be
 * shared, a reload keeps the card, Back closes it. Opening pushes a history entry,
 * switching to another user replaces it — so Back closes the card instead of
 * replaying every one viewed.
 */
export function useSelectedUserId() {
    const [params, setParams] = useSearchParams();
    const raw = params.get('user') ?? '';
    const id = INT_RE.test(raw) && Number(raw) > 0 ? Number(raw) : null;
    const open = (next) => setParams((prev) => {
        const p = new URLSearchParams(prev);
        p.set('user', String(next));
        return p;
    }, { replace: id != null });
    const close = () => setParams((prev) => {
        const p = new URLSearchParams(prev);
        p.delete('user');
        p.delete('tab');
        return p;
    }, { replace: true });
    return { id, open, close };
}
